<div class="header">
    <div class="frow-container height-100">
        <div class="frow row-between height-100 ">
            <div class="logo"><a routerLink="/"></a></div>
            <div class="menu frow centered">
                <button class="mr-30 social"><a href="https://twitter.com/tezzardz" target="_blank"><img
                            src="/assets/twitter.svg"></a></button>
                <button class="mr-30 social"><a href="https://discord.gg/ex5BDgx8Jc" target="_blank"><img
                            src="/assets/discord.svg"></a></button>
                <button *ngIf="!hasPermission" (click)="syncWallet()">Sync</button>
                <div *ngIf="hasPermission" class="address mr-20 ml-10">{{ walletAddress$ | async }}</div>
                <button *ngIf="hasPermission" (click)="unsyncWallet()">Unsync</button>

            </div>
        </div>
    </div>
</div>